/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiPlayerClassyearsGet$Any } from '../fn/player/api-player-classyears-get-any';
import { ApiPlayerClassyearsGet$Any$Params } from '../fn/player/api-player-classyears-get-any';
import { apiPlayerClassyearsGet$Json } from '../fn/player/api-player-classyears-get-json';
import { ApiPlayerClassyearsGet$Json$Params } from '../fn/player/api-player-classyears-get-json';
import { apiPlayerClassyearsGet$JsonOdataMetadataFull } from '../fn/player/api-player-classyears-get-json-odata-metadata-full';
import { ApiPlayerClassyearsGet$JsonOdataMetadataFull$Params } from '../fn/player/api-player-classyears-get-json-odata-metadata-full';
import { apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-classyears-get-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-classyears-get-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-classyears-get-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-classyears-get-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerClassyearsGet$JsonOdataMetadataMinimal } from '../fn/player/api-player-classyears-get-json-odata-metadata-minimal';
import { ApiPlayerClassyearsGet$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-classyears-get-json-odata-metadata-minimal';
import { apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-classyears-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-classyears-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-classyears-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-classyears-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerClassyearsGet$JsonOdataMetadataNone } from '../fn/player/api-player-classyears-get-json-odata-metadata-none';
import { ApiPlayerClassyearsGet$JsonOdataMetadataNone$Params } from '../fn/player/api-player-classyears-get-json-odata-metadata-none';
import { apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-classyears-get-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-classyears-get-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-classyears-get-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-classyears-get-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerClassyearsGet$JsonOdataStreamingFalse } from '../fn/player/api-player-classyears-get-json-odata-streaming-false';
import { ApiPlayerClassyearsGet$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-classyears-get-json-odata-streaming-false';
import { apiPlayerClassyearsGet$JsonOdataStreamingTrue } from '../fn/player/api-player-classyears-get-json-odata-streaming-true';
import { ApiPlayerClassyearsGet$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-classyears-get-json-odata-streaming-true';
import { apiPlayerClassyearsGet$Plain } from '../fn/player/api-player-classyears-get-plain';
import { ApiPlayerClassyearsGet$Plain$Params } from '../fn/player/api-player-classyears-get-plain';
import { apiPlayerClassyearsGet$Xml } from '../fn/player/api-player-classyears-get-xml';
import { ApiPlayerClassyearsGet$Xml$Params } from '../fn/player/api-player-classyears-get-xml';
import { apiPlayerCompetitionIdIdGet$Any } from '../fn/player/api-player-competition-id-id-get-any';
import { ApiPlayerCompetitionIdIdGet$Any$Params } from '../fn/player/api-player-competition-id-id-get-any';
import { apiPlayerCompetitionIdIdGet$Json } from '../fn/player/api-player-competition-id-id-get-json';
import { ApiPlayerCompetitionIdIdGet$Json$Params } from '../fn/player/api-player-competition-id-id-get-json';
import { apiPlayerCompetitionIdIdGet$JsonOdataMetadataFull } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-full';
import { ApiPlayerCompetitionIdIdGet$JsonOdataMetadataFull$Params } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-full';
import { apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-minimal';
import { ApiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-minimal';
import { apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerCompetitionIdIdGet$JsonOdataMetadataNone } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-none';
import { ApiPlayerCompetitionIdIdGet$JsonOdataMetadataNone$Params } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-none';
import { apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-competition-id-id-get-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerCompetitionIdIdGet$JsonOdataStreamingFalse } from '../fn/player/api-player-competition-id-id-get-json-odata-streaming-false';
import { ApiPlayerCompetitionIdIdGet$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-competition-id-id-get-json-odata-streaming-false';
import { apiPlayerCompetitionIdIdGet$JsonOdataStreamingTrue } from '../fn/player/api-player-competition-id-id-get-json-odata-streaming-true';
import { ApiPlayerCompetitionIdIdGet$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-competition-id-id-get-json-odata-streaming-true';
import { apiPlayerCompetitionIdIdGet$Plain } from '../fn/player/api-player-competition-id-id-get-plain';
import { ApiPlayerCompetitionIdIdGet$Plain$Params } from '../fn/player/api-player-competition-id-id-get-plain';
import { apiPlayerCompetitionIdIdGet$Xml } from '../fn/player/api-player-competition-id-id-get-xml';
import { ApiPlayerCompetitionIdIdGet$Xml$Params } from '../fn/player/api-player-competition-id-id-get-xml';
import { apiPlayerOptionsPost$Json$Any } from '../fn/player/api-player-options-post-json-any';
import { ApiPlayerOptionsPost$Json$Any$Params } from '../fn/player/api-player-options-post-json-any';
import { apiPlayerOptionsPost$Json$Json } from '../fn/player/api-player-options-post-json-json';
import { ApiPlayerOptionsPost$Json$Json$Params } from '../fn/player/api-player-options-post-json-json';
import { apiPlayerOptionsPost$Json$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-json-json-odata-metadata-full';
import { ApiPlayerOptionsPost$Json$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-json-json-odata-metadata-full';
import { apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-json-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-json-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$Json$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-json-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$Json$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-json-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-json-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-json-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$Json$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-json-json-odata-metadata-none';
import { ApiPlayerOptionsPost$Json$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-json-json-odata-metadata-none';
import { apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-json-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-json-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$Json$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-json-json-odata-streaming-false';
import { ApiPlayerOptionsPost$Json$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-json-odata-streaming-false';
import { apiPlayerOptionsPost$Json$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-json-json-odata-streaming-true';
import { ApiPlayerOptionsPost$Json$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-json-odata-streaming-true';
import { apiPlayerOptionsPost$Json$Plain } from '../fn/player/api-player-options-post-json-plain';
import { ApiPlayerOptionsPost$Json$Plain$Params } from '../fn/player/api-player-options-post-json-plain';
import { apiPlayerOptionsPost$Json$Xml } from '../fn/player/api-player-options-post-json-xml';
import { ApiPlayerOptionsPost$Json$Xml$Params } from '../fn/player/api-player-options-post-json-xml';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$Any } from '../fn/player/api-player-options-post-json-odata-metadata-full-any';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$Any$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-any';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$Json } from '../fn/player/api-player-options-post-json-odata-metadata-full-json';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$Json$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-json';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-full';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-full';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-none';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-none';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-json-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$Plain } from '../fn/player/api-player-options-post-json-odata-metadata-full-plain';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$Plain$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-plain';
import { apiPlayerOptionsPost$JsonOdataMetadataFull$Xml } from '../fn/player/api-player-options-post-json-odata-metadata-full-xml';
import { ApiPlayerOptionsPost$JsonOdataMetadataFull$Xml$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-xml';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Any } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-any';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-any';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Json } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-json-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Plain } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-plain';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-plain';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Xml } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-xml';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-false-xml';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Any } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-any';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-any';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Json } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-json-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Plain } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-plain';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-plain';
import { apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Xml } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-xml';
import { ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Params } from '../fn/player/api-player-options-post-json-odata-metadata-full-odata-streaming-true-xml';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$Any } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-any';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$Any$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-any';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$Json } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$Json$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-full';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-full';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-none';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-none';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-json-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$Plain } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-plain';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$Plain$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-plain';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimal$Xml } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-xml';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimal$Xml$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-xml';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-any';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-any';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-plain';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-plain';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-xml';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-false-xml';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-any';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-any';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-plain';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-plain';
import { apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-xml';
import { ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Params } from '../fn/player/api-player-options-post-json-odata-metadata-minimal-odata-streaming-true-xml';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$Any } from '../fn/player/api-player-options-post-json-odata-metadata-none-any';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$Any$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-any';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$Json } from '../fn/player/api-player-options-post-json-odata-metadata-none-json';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$Json$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-json';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-full';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-full';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-none';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-none';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-json-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$Plain } from '../fn/player/api-player-options-post-json-odata-metadata-none-plain';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$Plain$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-plain';
import { apiPlayerOptionsPost$JsonOdataMetadataNone$Xml } from '../fn/player/api-player-options-post-json-odata-metadata-none-xml';
import { ApiPlayerOptionsPost$JsonOdataMetadataNone$Xml$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-xml';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Any } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-any';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-any';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Json } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-json-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-plain';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-plain';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-xml';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-false-xml';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Any } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-any';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-any';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Json } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-json-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-plain';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-plain';
import { apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-xml';
import { ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Params } from '../fn/player/api-player-options-post-json-odata-metadata-none-odata-streaming-true-xml';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$Any } from '../fn/player/api-player-options-post-json-odata-streaming-false-any';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$Any$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-any';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$Json } from '../fn/player/api-player-options-post-json-odata-streaming-false-json';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$Json$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-json';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-full';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-full';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-none';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-none';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-json-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$Plain } from '../fn/player/api-player-options-post-json-odata-streaming-false-plain';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$Plain$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-plain';
import { apiPlayerOptionsPost$JsonOdataStreamingFalse$Xml } from '../fn/player/api-player-options-post-json-odata-streaming-false-xml';
import { ApiPlayerOptionsPost$JsonOdataStreamingFalse$Xml$Params } from '../fn/player/api-player-options-post-json-odata-streaming-false-xml';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$Any } from '../fn/player/api-player-options-post-json-odata-streaming-true-any';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$Any$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-any';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$Json } from '../fn/player/api-player-options-post-json-odata-streaming-true-json';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$Json$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-json';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-full';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-full';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-none';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-none';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-streaming-false';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-streaming-false';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-streaming-true';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-json-odata-streaming-true';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$Plain } from '../fn/player/api-player-options-post-json-odata-streaming-true-plain';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$Plain$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-plain';
import { apiPlayerOptionsPost$JsonOdataStreamingTrue$Xml } from '../fn/player/api-player-options-post-json-odata-streaming-true-xml';
import { ApiPlayerOptionsPost$JsonOdataStreamingTrue$Xml$Params } from '../fn/player/api-player-options-post-json-odata-streaming-true-xml';
import { apiPlayerOptionsPost$Plain$Any } from '../fn/player/api-player-options-post-plain-any';
import { ApiPlayerOptionsPost$Plain$Any$Params } from '../fn/player/api-player-options-post-plain-any';
import { apiPlayerOptionsPost$Plain$Json } from '../fn/player/api-player-options-post-plain-json';
import { ApiPlayerOptionsPost$Plain$Json$Params } from '../fn/player/api-player-options-post-plain-json';
import { apiPlayerOptionsPost$Plain$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-plain-json-odata-metadata-full';
import { ApiPlayerOptionsPost$Plain$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-plain-json-odata-metadata-full';
import { apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-plain-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-plain-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-plain-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-plain-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-plain-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$Plain$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-plain-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-plain-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-plain-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-plain-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-plain-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$Plain$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-plain-json-odata-metadata-none';
import { ApiPlayerOptionsPost$Plain$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-plain-json-odata-metadata-none';
import { apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-plain-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-plain-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-plain-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-plain-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$Plain$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-plain-json-odata-streaming-false';
import { ApiPlayerOptionsPost$Plain$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-plain-json-odata-streaming-false';
import { apiPlayerOptionsPost$Plain$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-plain-json-odata-streaming-true';
import { ApiPlayerOptionsPost$Plain$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-plain-json-odata-streaming-true';
import { apiPlayerOptionsPost$Plain$Plain } from '../fn/player/api-player-options-post-plain-plain';
import { ApiPlayerOptionsPost$Plain$Plain$Params } from '../fn/player/api-player-options-post-plain-plain';
import { apiPlayerOptionsPost$Plain$Xml } from '../fn/player/api-player-options-post-plain-xml';
import { ApiPlayerOptionsPost$Plain$Xml$Params } from '../fn/player/api-player-options-post-plain-xml';
import { apiPlayerOptionsPost$Xml$Any } from '../fn/player/api-player-options-post-xml-any';
import { ApiPlayerOptionsPost$Xml$Any$Params } from '../fn/player/api-player-options-post-xml-any';
import { apiPlayerOptionsPost$Xml$Json } from '../fn/player/api-player-options-post-xml-json';
import { ApiPlayerOptionsPost$Xml$Json$Params } from '../fn/player/api-player-options-post-xml-json';
import { apiPlayerOptionsPost$Xml$JsonOdataMetadataFull } from '../fn/player/api-player-options-post-xml-json-odata-metadata-full';
import { ApiPlayerOptionsPost$Xml$JsonOdataMetadataFull$Params } from '../fn/player/api-player-options-post-xml-json-odata-metadata-full';
import { apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-options-post-xml-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-xml-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-options-post-xml-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-xml-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimal } from '../fn/player/api-player-options-post-xml-json-odata-metadata-minimal';
import { ApiPlayerOptionsPost$Xml$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-options-post-xml-json-odata-metadata-minimal';
import { apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-options-post-xml-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-xml-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-options-post-xml-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-xml-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOptionsPost$Xml$JsonOdataMetadataNone } from '../fn/player/api-player-options-post-xml-json-odata-metadata-none';
import { ApiPlayerOptionsPost$Xml$JsonOdataMetadataNone$Params } from '../fn/player/api-player-options-post-xml-json-odata-metadata-none';
import { apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-options-post-xml-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-xml-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-options-post-xml-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-xml-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOptionsPost$Xml$JsonOdataStreamingFalse } from '../fn/player/api-player-options-post-xml-json-odata-streaming-false';
import { ApiPlayerOptionsPost$Xml$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-options-post-xml-json-odata-streaming-false';
import { apiPlayerOptionsPost$Xml$JsonOdataStreamingTrue } from '../fn/player/api-player-options-post-xml-json-odata-streaming-true';
import { ApiPlayerOptionsPost$Xml$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-options-post-xml-json-odata-streaming-true';
import { apiPlayerOptionsPost$Xml$Plain } from '../fn/player/api-player-options-post-xml-plain';
import { ApiPlayerOptionsPost$Xml$Plain$Params } from '../fn/player/api-player-options-post-xml-plain';
import { apiPlayerOptionsPost$Xml$Xml } from '../fn/player/api-player-options-post-xml-xml';
import { ApiPlayerOptionsPost$Xml$Xml$Params } from '../fn/player/api-player-options-post-xml-xml';
import { apiPlayerOverridesIdGet$Any } from '../fn/player/api-player-overrides-id-get-any';
import { ApiPlayerOverridesIdGet$Any$Params } from '../fn/player/api-player-overrides-id-get-any';
import { apiPlayerOverridesIdGet$Json } from '../fn/player/api-player-overrides-id-get-json';
import { ApiPlayerOverridesIdGet$Json$Params } from '../fn/player/api-player-overrides-id-get-json';
import { apiPlayerOverridesIdGet$JsonOdataMetadataFull } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-full';
import { ApiPlayerOverridesIdGet$JsonOdataMetadataFull$Params } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-full';
import { apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerOverridesIdGet$JsonOdataMetadataMinimal } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-minimal';
import { ApiPlayerOverridesIdGet$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-minimal';
import { apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerOverridesIdGet$JsonOdataMetadataNone } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-none';
import { ApiPlayerOverridesIdGet$JsonOdataMetadataNone$Params } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-none';
import { apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-overrides-id-get-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerOverridesIdGet$JsonOdataStreamingFalse } from '../fn/player/api-player-overrides-id-get-json-odata-streaming-false';
import { ApiPlayerOverridesIdGet$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-overrides-id-get-json-odata-streaming-false';
import { apiPlayerOverridesIdGet$JsonOdataStreamingTrue } from '../fn/player/api-player-overrides-id-get-json-odata-streaming-true';
import { ApiPlayerOverridesIdGet$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-overrides-id-get-json-odata-streaming-true';
import { apiPlayerOverridesIdGet$Plain } from '../fn/player/api-player-overrides-id-get-plain';
import { ApiPlayerOverridesIdGet$Plain$Params } from '../fn/player/api-player-overrides-id-get-plain';
import { apiPlayerOverridesIdGet$Xml } from '../fn/player/api-player-overrides-id-get-xml';
import { ApiPlayerOverridesIdGet$Xml$Params } from '../fn/player/api-player-overrides-id-get-xml';
import { apiPlayerPlayersGet$Any } from '../fn/player/api-player-players-get-any';
import { ApiPlayerPlayersGet$Any$Params } from '../fn/player/api-player-players-get-any';
import { apiPlayerPlayersGet$Json } from '../fn/player/api-player-players-get-json';
import { ApiPlayerPlayersGet$Json$Params } from '../fn/player/api-player-players-get-json';
import { apiPlayerPlayersGet$JsonOdataMetadataFull } from '../fn/player/api-player-players-get-json-odata-metadata-full';
import { ApiPlayerPlayersGet$JsonOdataMetadataFull$Params } from '../fn/player/api-player-players-get-json-odata-metadata-full';
import { apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-players-get-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-players-get-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-players-get-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-players-get-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerPlayersGet$JsonOdataMetadataMinimal } from '../fn/player/api-player-players-get-json-odata-metadata-minimal';
import { ApiPlayerPlayersGet$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-players-get-json-odata-metadata-minimal';
import { apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-players-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-players-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-players-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-players-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerPlayersGet$JsonOdataMetadataNone } from '../fn/player/api-player-players-get-json-odata-metadata-none';
import { ApiPlayerPlayersGet$JsonOdataMetadataNone$Params } from '../fn/player/api-player-players-get-json-odata-metadata-none';
import { apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-players-get-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-players-get-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-players-get-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-players-get-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerPlayersGet$JsonOdataStreamingFalse } from '../fn/player/api-player-players-get-json-odata-streaming-false';
import { ApiPlayerPlayersGet$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-players-get-json-odata-streaming-false';
import { apiPlayerPlayersGet$JsonOdataStreamingTrue } from '../fn/player/api-player-players-get-json-odata-streaming-true';
import { ApiPlayerPlayersGet$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-players-get-json-odata-streaming-true';
import { apiPlayerPlayersGet$Plain } from '../fn/player/api-player-players-get-plain';
import { ApiPlayerPlayersGet$Plain$Params } from '../fn/player/api-player-players-get-plain';
import { apiPlayerPlayersGet$Xml } from '../fn/player/api-player-players-get-xml';
import { ApiPlayerPlayersGet$Xml$Params } from '../fn/player/api-player-players-get-xml';
import { apiPlayerPositionsGet$Any } from '../fn/player/api-player-positions-get-any';
import { ApiPlayerPositionsGet$Any$Params } from '../fn/player/api-player-positions-get-any';
import { apiPlayerPositionsGet$Json } from '../fn/player/api-player-positions-get-json';
import { ApiPlayerPositionsGet$Json$Params } from '../fn/player/api-player-positions-get-json';
import { apiPlayerPositionsGet$JsonOdataMetadataFull } from '../fn/player/api-player-positions-get-json-odata-metadata-full';
import { ApiPlayerPositionsGet$JsonOdataMetadataFull$Params } from '../fn/player/api-player-positions-get-json-odata-metadata-full';
import { apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/player/api-player-positions-get-json-odata-metadata-full-odata-streaming-false';
import { ApiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/player/api-player-positions-get-json-odata-metadata-full-odata-streaming-false';
import { apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/player/api-player-positions-get-json-odata-metadata-full-odata-streaming-true';
import { ApiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/player/api-player-positions-get-json-odata-metadata-full-odata-streaming-true';
import { apiPlayerPositionsGet$JsonOdataMetadataMinimal } from '../fn/player/api-player-positions-get-json-odata-metadata-minimal';
import { ApiPlayerPositionsGet$JsonOdataMetadataMinimal$Params } from '../fn/player/api-player-positions-get-json-odata-metadata-minimal';
import { apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/player/api-player-positions-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/player/api-player-positions-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/player/api-player-positions-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/player/api-player-positions-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiPlayerPositionsGet$JsonOdataMetadataNone } from '../fn/player/api-player-positions-get-json-odata-metadata-none';
import { ApiPlayerPositionsGet$JsonOdataMetadataNone$Params } from '../fn/player/api-player-positions-get-json-odata-metadata-none';
import { apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/player/api-player-positions-get-json-odata-metadata-none-odata-streaming-false';
import { ApiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/player/api-player-positions-get-json-odata-metadata-none-odata-streaming-false';
import { apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/player/api-player-positions-get-json-odata-metadata-none-odata-streaming-true';
import { ApiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/player/api-player-positions-get-json-odata-metadata-none-odata-streaming-true';
import { apiPlayerPositionsGet$JsonOdataStreamingFalse } from '../fn/player/api-player-positions-get-json-odata-streaming-false';
import { ApiPlayerPositionsGet$JsonOdataStreamingFalse$Params } from '../fn/player/api-player-positions-get-json-odata-streaming-false';
import { apiPlayerPositionsGet$JsonOdataStreamingTrue } from '../fn/player/api-player-positions-get-json-odata-streaming-true';
import { ApiPlayerPositionsGet$JsonOdataStreamingTrue$Params } from '../fn/player/api-player-positions-get-json-odata-streaming-true';
import { apiPlayerPositionsGet$Plain } from '../fn/player/api-player-positions-get-plain';
import { ApiPlayerPositionsGet$Plain$Params } from '../fn/player/api-player-positions-get-plain';
import { apiPlayerPositionsGet$Xml } from '../fn/player/api-player-positions-get-xml';
import { ApiPlayerPositionsGet$Xml$Params } from '../fn/player/api-player-positions-get-xml';
import { ObjectResult } from '../models/object-result';
import { PlayerDetailsViewModelResult } from '../models/player-details-view-model-result';
import { PlayerModelListResult } from '../models/player-model-list-result';
import { PlayerOverridesViewModelResult } from '../models/player-overrides-view-model-result';
import { StringListResult } from '../models/string-list-result';

@Injectable({ providedIn: 'root' })
export class PlayerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiPlayerOverridesIdGet()` */
  static readonly ApiPlayerOverridesIdGetPath = '/api/player/overrides/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params: ApiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingTrue(params: ApiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params: ApiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingFalse(params: ApiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataMinimal$Response(params: ApiPlayerOverridesIdGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataMinimal(params: ApiPlayerOverridesIdGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params: ApiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue(params: ApiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params: ApiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingFalse(params: ApiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataFull$Response(params: ApiPlayerOverridesIdGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataFull(params: ApiPlayerOverridesIdGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params: ApiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingTrue(params: ApiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params: ApiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingFalse(params: ApiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataNone$Response(params: ApiPlayerOverridesIdGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataMetadataNone(params: ApiPlayerOverridesIdGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataStreamingTrue$Response(params: ApiPlayerOverridesIdGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataStreamingTrue(params: ApiPlayerOverridesIdGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataStreamingFalse$Response(params: ApiPlayerOverridesIdGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$JsonOdataStreamingFalse(params: ApiPlayerOverridesIdGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$Json$Response(params: ApiPlayerOverridesIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$Json(params: ApiPlayerOverridesIdGet$Json$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$Xml$Response(params: ApiPlayerOverridesIdGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$Xml(params: ApiPlayerOverridesIdGet$Xml$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$Plain$Response(params: ApiPlayerOverridesIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$Plain(params: ApiPlayerOverridesIdGet$Plain$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOverridesIdGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$Any$Response(params: ApiPlayerOverridesIdGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
    return apiPlayerOverridesIdGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOverridesIdGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerOverridesIdGet$Any(params: ApiPlayerOverridesIdGet$Any$Params, context?: HttpContext): Observable<PlayerOverridesViewModelResult> {
    return this.apiPlayerOverridesIdGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerOverridesViewModelResult>): PlayerOverridesViewModelResult => r.body)
    );
  }

  /** Path part for operation `apiPlayerCompetitionIdIdGet()` */
  static readonly ApiPlayerCompetitionIdIdGetPath = '/api/player/{competitionId}/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingTrue(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingFalse(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal$Response(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingTrue(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingFalse(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataFull$Response(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataFull(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingTrue(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingFalse(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataNone$Response(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataMetadataNone(params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataStreamingTrue$Response(params: ApiPlayerCompetitionIdIdGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataStreamingTrue(params: ApiPlayerCompetitionIdIdGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataStreamingFalse$Response(params: ApiPlayerCompetitionIdIdGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$JsonOdataStreamingFalse(params: ApiPlayerCompetitionIdIdGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$Json$Response(params: ApiPlayerCompetitionIdIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$Json(params: ApiPlayerCompetitionIdIdGet$Json$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$Xml$Response(params: ApiPlayerCompetitionIdIdGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$Xml(params: ApiPlayerCompetitionIdIdGet$Xml$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$Plain$Response(params: ApiPlayerCompetitionIdIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$Plain(params: ApiPlayerCompetitionIdIdGet$Plain$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerCompetitionIdIdGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$Any$Response(params: ApiPlayerCompetitionIdIdGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
    return apiPlayerCompetitionIdIdGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerCompetitionIdIdGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerCompetitionIdIdGet$Any(params: ApiPlayerCompetitionIdIdGet$Any$Params, context?: HttpContext): Observable<PlayerDetailsViewModelResult> {
    return this.apiPlayerCompetitionIdIdGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerDetailsViewModelResult>): PlayerDetailsViewModelResult => r.body)
    );
  }

  /** Path part for operation `apiPlayerPlayersGet()` */
  static readonly ApiPlayerPlayersGetPath = '/api/player/players';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataMinimal$Response(params?: ApiPlayerPlayersGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataMinimal(params?: ApiPlayerPlayersGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataFull$Response(params?: ApiPlayerPlayersGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataFull(params?: ApiPlayerPlayersGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataNone$Response(params?: ApiPlayerPlayersGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataMetadataNone(params?: ApiPlayerPlayersGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataStreamingTrue$Response(params?: ApiPlayerPlayersGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataStreamingTrue(params?: ApiPlayerPlayersGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataStreamingFalse$Response(params?: ApiPlayerPlayersGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$JsonOdataStreamingFalse(params?: ApiPlayerPlayersGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$Json$Response(params?: ApiPlayerPlayersGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$Json(params?: ApiPlayerPlayersGet$Json$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$Xml$Response(params?: ApiPlayerPlayersGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$Xml(params?: ApiPlayerPlayersGet$Xml$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$Plain$Response(params?: ApiPlayerPlayersGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$Plain(params?: ApiPlayerPlayersGet$Plain$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPlayersGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$Any$Response(params?: ApiPlayerPlayersGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerModelListResult>> {
    return apiPlayerPlayersGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPlayersGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPlayersGet$Any(params?: ApiPlayerPlayersGet$Any$Params, context?: HttpContext): Observable<PlayerModelListResult> {
    return this.apiPlayerPlayersGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlayerModelListResult>): PlayerModelListResult => r.body)
    );
  }

  /** Path part for operation `apiPlayerClassyearsGet()` */
  static readonly ApiPlayerClassyearsGetPath = '/api/player/classyears';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataMinimal$Response(params?: ApiPlayerClassyearsGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataMinimal(params?: ApiPlayerClassyearsGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataFull$Response(params?: ApiPlayerClassyearsGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataFull(params?: ApiPlayerClassyearsGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataNone$Response(params?: ApiPlayerClassyearsGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataMetadataNone(params?: ApiPlayerClassyearsGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataStreamingTrue$Response(params?: ApiPlayerClassyearsGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataStreamingTrue(params?: ApiPlayerClassyearsGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataStreamingFalse$Response(params?: ApiPlayerClassyearsGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$JsonOdataStreamingFalse(params?: ApiPlayerClassyearsGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$Json$Response(params?: ApiPlayerClassyearsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$Json(params?: ApiPlayerClassyearsGet$Json$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$Xml$Response(params?: ApiPlayerClassyearsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$Xml(params?: ApiPlayerClassyearsGet$Xml$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$Plain$Response(params?: ApiPlayerClassyearsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$Plain(params?: ApiPlayerClassyearsGet$Plain$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerClassyearsGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$Any$Response(params?: ApiPlayerClassyearsGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerClassyearsGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerClassyearsGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerClassyearsGet$Any(params?: ApiPlayerClassyearsGet$Any$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerClassyearsGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /** Path part for operation `apiPlayerPositionsGet()` */
  static readonly ApiPlayerPositionsGetPath = '/api/player/positions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataMinimal$Response(params?: ApiPlayerPositionsGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataMinimal(params?: ApiPlayerPositionsGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataFull$Response(params?: ApiPlayerPositionsGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataFull(params?: ApiPlayerPositionsGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataNone$Response(params?: ApiPlayerPositionsGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataMetadataNone(params?: ApiPlayerPositionsGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataStreamingTrue$Response(params?: ApiPlayerPositionsGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataStreamingTrue(params?: ApiPlayerPositionsGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataStreamingFalse$Response(params?: ApiPlayerPositionsGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$JsonOdataStreamingFalse(params?: ApiPlayerPositionsGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$Json$Response(params?: ApiPlayerPositionsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$Json(params?: ApiPlayerPositionsGet$Json$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$Xml$Response(params?: ApiPlayerPositionsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$Xml(params?: ApiPlayerPositionsGet$Xml$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$Plain$Response(params?: ApiPlayerPositionsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$Plain(params?: ApiPlayerPositionsGet$Plain$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerPositionsGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$Any$Response(params?: ApiPlayerPositionsGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiPlayerPositionsGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerPositionsGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlayerPositionsGet$Any(params?: ApiPlayerPositionsGet$Any$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiPlayerPositionsGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /** Path part for operation `apiPlayerOptionsPost()` */
  static readonly ApiPlayerOptionsPostPath = '/api/player/options';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$Json$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$Json(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$Xml$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$Xml(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$Plain$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$Plain(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataMinimal$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$Any$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataMinimal$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataMinimal$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataMinimal$Any(params?: ApiPlayerOptionsPost$JsonOdataMetadataMinimal$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataMinimal$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Json(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Xml(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Plain(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Any(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Json(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Xml(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Plain(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Any(params?: ApiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$Json$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$Json(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$Xml$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$Xml(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$Plain$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$Plain(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataFull$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$Any$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataFull$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataFull$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataFull$Any(params?: ApiPlayerOptionsPost$JsonOdataMetadataFull$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataFull$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Json(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Any(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Json(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Any(params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$Json$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$Json(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$Xml$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$Xml(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$Plain$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$Plain(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataMetadataNone$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$Any$Response(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataMetadataNone$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataMetadataNone$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiPlayerOptionsPost$JsonOdataMetadataNone$Any(params?: ApiPlayerOptionsPost$JsonOdataMetadataNone$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataMetadataNone$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$Json()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$Json$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$Json$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$Json(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$Xml()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$Xml$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$Xml(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$Plain()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$Plain$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$Plain(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingTrue$Any()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$Any$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingTrue$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingTrue$Any$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingTrue$Any(params?: ApiPlayerOptionsPost$JsonOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingTrue$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$Json()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$Json$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$Json$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$Json(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$Xml()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$Xml$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$Xml(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$Plain()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$Plain$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$Plain(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$JsonOdataStreamingFalse$Any()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$Any$Response(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$JsonOdataStreamingFalse$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$JsonOdataStreamingFalse$Any$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiPlayerOptionsPost$JsonOdataStreamingFalse$Any(params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$JsonOdataStreamingFalse$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$Json$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$Json$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$Json$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$Json$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$Json$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$Json$Response(params?: ApiPlayerOptionsPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$Json(params?: ApiPlayerOptionsPost$Json$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$Xml$Response(params?: ApiPlayerOptionsPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$Xml(params?: ApiPlayerOptionsPost$Json$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$Plain$Response(params?: ApiPlayerOptionsPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$Plain(params?: ApiPlayerOptionsPost$Json$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Json$Any()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$Any$Response(params?: ApiPlayerOptionsPost$Json$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Json$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Json$Any$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlayerOptionsPost$Json$Any(params?: ApiPlayerOptionsPost$Json$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Json$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$Xml$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$Xml$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$Xml$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$Xml$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$Xml$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$Json()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$Json$Response(params?: ApiPlayerOptionsPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$Json(params?: ApiPlayerOptionsPost$Xml$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$Xml()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$Xml$Response(params?: ApiPlayerOptionsPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$Xml(params?: ApiPlayerOptionsPost$Xml$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$Plain()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$Plain$Response(params?: ApiPlayerOptionsPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$Plain(params?: ApiPlayerOptionsPost$Xml$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Xml$Any()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$Any$Response(params?: ApiPlayerOptionsPost$Xml$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Xml$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Xml$Any$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiPlayerOptionsPost$Xml$Any(params?: ApiPlayerOptionsPost$Xml$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Xml$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimal$Response(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimal(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$JsonOdataMetadataFull()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataFull$Response(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataFull(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$JsonOdataMetadataNone()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataNone$Response(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataMetadataNone(params?: ApiPlayerOptionsPost$Plain$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataStreamingTrue$Response(params?: ApiPlayerOptionsPost$Plain$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataStreamingTrue(params?: ApiPlayerOptionsPost$Plain$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataStreamingFalse$Response(params?: ApiPlayerOptionsPost$Plain$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$JsonOdataStreamingFalse(params?: ApiPlayerOptionsPost$Plain$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$Json()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$Json$Response(params?: ApiPlayerOptionsPost$Plain$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$Json$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$Json(params?: ApiPlayerOptionsPost$Plain$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$Xml()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$Xml$Response(params?: ApiPlayerOptionsPost$Plain$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$Xml$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$Xml(params?: ApiPlayerOptionsPost$Plain$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$Plain()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$Plain$Response(params?: ApiPlayerOptionsPost$Plain$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$Plain$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$Plain(params?: ApiPlayerOptionsPost$Plain$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlayerOptionsPost$Plain$Any()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$Any$Response(params?: ApiPlayerOptionsPost$Plain$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiPlayerOptionsPost$Plain$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlayerOptionsPost$Plain$Any$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiPlayerOptionsPost$Plain$Any(params?: ApiPlayerOptionsPost$Plain$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiPlayerOptionsPost$Plain$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

}
